import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "current", "preview"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return this.reset()

    this.revoke()
    this.objectUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.objectUrl
    this.previewTarget.classList.remove("hidden")
    this.currentTarget.classList.add("hidden")
  }

  reset() {
    this.revoke()
    this.previewTarget.classList.add("hidden")
    this.currentTarget.classList.remove("hidden")
  }

  disconnect() {
    this.revoke()
  }

  revoke() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
